import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateLeagueEdit = {
  leagueEdit: { data: null, loading: false, error: null },
};

export const leagueEdit = createAsyncThunk('user/leagueEdit', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .post(`/league/edit/${data.leagueId}`, data)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerLeagueEdit = {
  [leagueEdit.pending]: (state) => {
    state.leagueEdit.loading = true;
  },
  [leagueEdit.fulfilled]: (state, action) => {
    state.leagueEdit.loading = false;
    state.leagueEdit.data = action.payload;
    state.leagueEdit.error = null;
  },
  [leagueEdit.rejected]: (state, action) => {
    state.leagueEdit.data = null;
    state.leagueEdit.loading = false;
    state.leagueEdit.error = action.payload;
  },
};
